// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__18YOu","loaderOuter":"PageOverlayLoader_loaderOuter__1dbi5"};